import { render } from "./PopularHosts.vue?vue&type=template&id=093fd481&ts=true"
import script from "./PopularHosts.vue?vue&type=script&lang=ts"
export * from "./PopularHosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__